import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import styles from './PaymentInfo.module.scss';
import useHandlePaymentSelection from './hooks/useHandlePaymentSelection';
import CreditCard from './CreditCard';
import PayPal from './PayPal';
import ApplePay from './ApplePay';
import paypalRadioLogo from './assets/img/paypal-logo-radio.png';
import applePayRadioLogo from './assets/img/apple-pay-logo-radio.png';
import creditCardLogo from './assets/img/credit-card.png';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import { showApplePay } from './paymentInfoUtils';

function PaymentInfo() {
  const { viewSize, showPaymentForm, flags } = useAppContext();
  const { friend } = useFriendContext();
  const { paymentType, handleOnSelect } = useHandlePaymentSelection();
  const [showApplePayOption, setShowApplePayOption] = useState(false);

  useEffect(() => { showApplePay(flags, setShowApplePayOption); }, [flags]);
  return (
    <section className={`${styles.paymentInfo} ${styles[viewSize]}`}>
      <h3 className={styles.title}>Add Payment Information</h3>
      {friend.address && showPaymentForm && (
        <>
          <div className={styles.divider} />
          <div className={styles.form}>
            <div className={styles.description}>
              <p>
                Don’t worry, your card will only be charged if you shop with us!
                Also don’t forget that you can unlock an
                {' '}
                <b>automatic $10 credit</b>
                {' '}
                when
                you and the friend who invited you shop the sale.
              </p>
              <p>
                Product supplies are limited, so hurry and add your payment info
                so you can be ready to shop!
              </p>
            </div>
            <div className={styles.paymentTypes}>
              <h4 className={styles.paymentTypeTitle}>Select Payment Type</h4>
              <div className={styles.paymentSelection}>
                <label htmlFor="creditCard">
                  <input type="radio" id="creditCard" name="payment" data-testid="creditCard" onClick={handleOnSelect} defaultChecked />
                  <span className={styles.paymentRadio} />
                  <img src={creditCardLogo} alt="Credit Card or Debit Card" className={styles.creditCardLogo} />
                  {' '}
                  Credit Card or Debit Card
                </label>
                <label htmlFor="paypal">
                  <input
                    type="radio"
                    id="paypal"
                    name="payment"
                    data-testid="paypal"
                    onClick={handleOnSelect}
                  />
                  <span className={styles.paymentRadio} />
                  <img src={paypalRadioLogo} alt="PayPal" className={styles.payPalRadioLogo} />
                </label>
                {showApplePayOption && (
                <label htmlFor="applepay">
                  <input
                    type="radio"
                    id="applepay"
                    name="payment"
                    data-testid="applepay"
                    onClick={handleOnSelect}
                  />
                  <span className={styles.paymentRadio} />
                  <img src={applePayRadioLogo} alt="PayPal" className={styles.applePayRadioLogo} />
                </label>
                )}
              </div>
              <div className={styles.paymentAction}>
                {paymentType === 'creditCard'
                && <CreditCard />}
              </div>
              {paymentType === 'paypal' && <PayPal />}
              {paymentType === 'applepay' && <ApplePay />}
            </div>
          </div>
        </>
      )}
      <div id="hcaptchaWidget" className="h-captcha" />
    </section>
  );
}

export default PaymentInfo;
